import type { ComponentProps } from 'react';
import { cn } from '../../../utils/tw-merge';

export type IconProps = ComponentProps<'span'> & {
  name: string;
};

export const Icon = ({ className, name, ...props }: IconProps) => {
  return (
    <span className={cn(`iconify ${name}`, className)} role="img" {...props} />
  );
};
